import React from 'react';
import { Helmet } from 'react-helmet-async';

const seoData = {
  '/': {
    title: 'NSTU India Pvt. Ltd. | Government IT Solutions & Digital Transformation',
    description: 'NSTU India - Leading IT solutions provider for Government e-Governance projects and enterprise digital transformation. 15+ years experience, 50+ government clients across India.',
    keywords: 'NSTU India, Government IT Projects, e-Governance Solutions, Digital Transformation, Smart City, Digital India',
  },
  '/about': {
    title: 'About NSTU India | Government IT Partner Since 2009',
    description: 'Learn about NSTU India Pvt. Ltd. - National Services Technical Unit. 15+ years of excellence in government IT projects, ISO certified, STQC empanelled, serving 50+ government clients.',
    keywords: 'About NSTU, NSTU History, Government IT Partner, ISO Certified IT Company India',
  },
  '/services': {
    title: 'IT Services | e-Governance, Software Development, Data Analytics - NSTU India',
    description: 'Comprehensive IT services: e-Governance solutions, custom software development, network infrastructure, data analytics, IT consulting & hardware solutions for government and enterprises.',
    keywords: 'e-Governance Services, Government Software Development, IT Consulting India, Data Analytics, Network Infrastructure',
  },
  '/government-projects': {
    title: 'Government IT Projects | e-Governance Success Stories - NSTU India',
    description: 'Explore NSTU India\'s government IT projects - State Revenue Portals, Smart City Command Centers, Digital Health Records, Public Grievance Systems & more. 100+ projects delivered.',
    keywords: 'Government IT Projects, e-Governance Projects India, Smart City Projects, Digital India Projects, State Government IT',
  },
  '/private-projects': {
    title: 'Enterprise IT Solutions | Banking, Manufacturing, Retail - NSTU India',
    description: 'Enterprise IT solutions by NSTU India - ERP implementations, banking systems, e-commerce platforms, and custom software for manufacturing, retail, and healthcare sectors.',
    keywords: 'Enterprise IT Solutions, ERP Implementation India, Banking Software, Custom Enterprise Software',
  },
  '/contact': {
    title: 'Contact NSTU India | Get IT Solutions Quote | +91 94680 38060',
    description: 'Contact NSTU India for government IT projects and enterprise solutions. Call +91 94680 38060 or email info@nstuindia.com. Office at VPO Haluwas, Bhiwani, Haryana.',
    keywords: 'Contact NSTU, NSTU Phone Number, Government IT Vendor Contact, IT Solutions Quote Haryana',
  },
  '/media': {
    title: 'Media Coverage & News | NSTU India in Dainik Bhaskar',
    description: 'NSTU India featured in Dainik Bhaskar - Property tax bill distribution, citizen services, and government IT project coverage. View our press gallery.',
    keywords: 'NSTU India News, Dainik Bhaskar, Media Coverage, Press Release, Government IT News India',
  },
};

export const SEO = ({ pathname }) => {
  const data = seoData[pathname] || seoData['/'];
  const url = `https://nstu.in${pathname}`;

  return (
    <Helmet>
      <title>{data.title}</title>
      <meta name="description" content={data.description} />
      <meta name="keywords" content={data.keywords} />
      <link rel="canonical" href={url} />
      
      {/* Open Graph */}
      <meta property="og:title" content={data.title} />
      <meta property="og:description" content={data.description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      
      {/* Twitter */}
      <meta name="twitter:title" content={data.title} />
      <meta name="twitter:description" content={data.description} />
    </Helmet>
  );
};

export default SEO;
